import { render } from "./TeachersList.vue?vue&type=template&id=1b2be0c2"
import script from "./TeachersList.vue?vue&type=script&lang=js"
export * from "./TeachersList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__